import NextRouter from 'next/router'
import { getCookie } from '@jarvis.oddle/core/tools/cookie'
import { isEmpty, pad } from 'src/utils/string'

export const localeRegex = /^[A-z][A-z]_[A-z][A-z]$/

interface ParseUrlResponse {
  path: string[]
  locale: string
  previewToken: string
  previewMode: string
}

export const parseUrl = (
  url: string
): ParseUrlResponse => {
  if (isEmpty(url)) return {} as ParseUrlResponse
  const path = url
    .split('#')[0]
    .substring(0, url.indexOf('?') !== -1 ? url.indexOf('?') : url.length)
    .split('/')
    .filter((e) => e !== '')
  let locale, previewToken
  // WORKAROUND: String is used for previewMode as next/Link will parse the href object and all queries will be parsed as string.
  let previewMode = 'false'
  if (path[0] && localeRegex.test(path[0])) {
    locale = path[0]
      .split('_')
      .map((part, index) =>
        index === 0 ? part.toLowerCase() : part.toUpperCase()
      )
      .join('_')
    path.shift()
  }
  const params = new URLSearchParams(url)
  if (params.get('previewMode') === 'true') {
    previewMode = 'true'
    previewToken = params.get('previewToken')
    if (url.includes('productId=preview')) {
      path.push('product')
    }
  }
  return { path, locale, previewToken, previewMode }
}

export const redirect = ({
  url,
  as,
  scroll = true,
  replace = false,
  shallow = false
}: {
  url: string
  as: string
  scroll?: boolean
  replace?: boolean
  shallow?: boolean
}): void => {
  // TODO: remove this part when use new version for next/router which support scroll to top
  if (typeof window !== 'undefined' && scroll) {
    window.scrollTo(0, 0)
  }

  if (replace) {
    NextRouter.replace(url, as, { shallow })
  } else {
    NextRouter.push(url, as, { shallow })
  }
}

export const makeQueryString = (params = {}) : string => {
  const queryString = Object.keys(params)
    .map((key) => params[key] && `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .filter(x => x)
    .join('&')
  return queryString !== '' ? `?${queryString}` : ''
}

export const verifyUrl = ({ url, path }: { url: string, path: string[] }): boolean => {
  const checkDuplicateLocaleCode = (url || '').match(/(\/[a-z]{2}_[A-Z]{2}){2}/g) || []
  // the max length should be 5 because checkout page have longest path with 5
  // shouldn't remove this blocker because it help us block any calling api at UserContext when Shop was accessed with invalid url
  return checkDuplicateLocaleCode.length <= 1 && path.length < 6
}

export const dateToRequestString = (input: Date | string): string => {
  if (!input) return input as string
  const date = (input as Date).getDate ? input as Date : new Date(input)
  return `${date.getDate()} ${pad('' + (date.getMonth() + 1))} ${date.getFullYear()}`
}

export const getCurrentUrl = (req, asPath) => req ? `//${getCookie(req.get?.('Cookie') || req.headers?.cookie || '', 'Custom-Url') || req.get?.('host') || req.headers?.host}${req.originalUrl}` : `//${window.location.host}${asPath}`

export const createUrl = (_url: string): string => {
  const url = _url || '/'
  return url.startsWith('#') || url.startsWith('?') || url.startsWith('/') || url.includes('://') ? url : `http://${url}`
}
